export default "__VITE_ASSET__DdYdbQY4__"